import { TelemetryEvents } from '@monorepo/shared/src/types';
import BaseTelemetryProvider from '@monorepo/shared/src/providers/BaseTelemetryProvider';
import CREATE_ACCESS_ACTIVITY_EVENT from 'graph/mutations/create-access-activity-event';
import CREATE_ACCESS_ACTIVITY_PAGE_EVENT from 'graph/mutations/create-access-activity-page-event';
import CREATE_ACCESS_LINK_EVENT from 'graph/mutations/create-access-link-event';
import CREATE_ACCESS_RESOURCE_EVENT from 'graph/mutations/create-access-resource-event';
import CREATE_READ_BOOK_EVENT from 'graph/mutations/create-read-book-event';

const mutationMap = {
  [TelemetryEvents.ACCESS_ACTIVITY]: CREATE_ACCESS_ACTIVITY_EVENT,
  [TelemetryEvents.ACCESS_ACTIVITY_PAGE]: CREATE_ACCESS_ACTIVITY_PAGE_EVENT,
  [TelemetryEvents.ACCESS_LINK]: CREATE_ACCESS_LINK_EVENT,
  [TelemetryEvents.ACCESS_RESOURCE]: CREATE_ACCESS_RESOURCE_EVENT,
  [TelemetryEvents.READ_BOOK]: CREATE_READ_BOOK_EVENT,
};

const TelemetryProvider = (props) => {
  return (
    <BaseTelemetryProvider {...props} telemetryEventsMutationMap={mutationMap}>
      {props.children}
    </BaseTelemetryProvider>
  );
};

export default TelemetryProvider;
